import axios from 'axios';

const STRAPI_URL = process.env.REACT_APP_STRAPI_URL || 'http://localhost:1337';

const client = axios.create({ baseURL: STRAPI_URL });

export const CATEGORIES = [
  'Politics',
  'Business',
  'Technology',
  'Science',
  'Health',
  'U.S.',
  'World',
  'Opinion',
];

/**
 * Fetch a page of articles, newest first, each populated with its
 * journalist, publication, and tags. Optionally filtered by category.
 */
export async function getArticles({ category, page = 1, pageSize = 10 } = {}) {
  const params = {
    populate: 'journalist,publication,tags',
    sort: 'publishedDate:desc',
    'pagination[page]': page,
    'pagination[pageSize]': pageSize,
  };
  if (category && category !== 'All') {
    params['filters[category][$eq]'] = category;
  }
  const res = await client.get('/api/articles', { params });
  return res.data; // { data: [...], meta: { pagination: {...} } }
}

/**
 * Fetch a single article by id, populated with its journalist,
 * publication, and tags.
 */
export async function getArticle(id) {
  const res = await client.get(`/api/articles/${id}`, {
    params: {
      populate: 'journalist,publication,tags',
    },
  });
  return res.data; // { data: {...} }
}

/**
 * Fetch the full roster of journalists, alphabetical by last name,
 * populated with the publications they write for.
 */
export async function getJournalists() {
  const res = await client.get('/api/journalists', {
    params: {
      sort: 'lastName:asc',
      'pagination[pageSize]': 100,
      populate: 'publications',
    },
  });
  return res.data; // { data: [...] }
}

/**
 * Fetch a single journalist by id, populated with their articles
 * (including each article's publication and tags) and the
 * publications they write for.
 */
export async function getJournalist(id) {
  const res = await client.get(`/api/journalists/${id}`, {
    params: {
      'populate[articles][populate][0]': 'publication',
      'populate[articles][populate][1]': 'tags',
      'populate[publications]': true,
    },
  });
  return res.data; // { data: {...} }
}

/**
 * Fetch the full roster of publications, alphabetical by name.
 */
export async function getPublications() {
  const res = await client.get('/api/publications', {
    params: {
      sort: 'name:asc',
      'pagination[pageSize]': 100,
    },
  });
  return res.data; // { data: [...] }
}

/**
 * Subscribe a reader to the daily newsletter.
 */
export async function subscribe({ name, email }) {
  const res = await client.post('/api/subscribers', { data: { name, email } });
  return res.data;
}

export default client;
